export const GREENHOUSE_JOBS_URL =
  'https://boards-api.greenhouse.io/v1/boards/skyscanner/jobs?content=true';

export const GREENHOUSE_SINGLE_JOB_BASE_URL =
  'https://boards-api.greenhouse.io/v1/boards/skyscanner/jobs/';

// Skyscanner's Ashby job board is identified by a UUID, not the string "skyscanner"
// (the "skyscanner" board name returns 404 / no data).
const ASHBY_JOB_BOARD_ID = 'eb485598-6bf3-40a5-8560-d70150131305';

// Public Job Posting API — used to fetch job data (list + single job).
export const ASHBY_JOBS_URL = `https://api.ashbyhq.com/posting-api/job-board/${ASHBY_JOB_BOARD_ID}`;

// Hosted job board URL — used by the Ashby embed script as `ashbyBaseJobBoardUrl`
// when rendering the in-page application form. This is a different host from the
// data API above.
export const ASHBY_JOB_BOARD_URL = `https://jobs.ashbyhq.com/${ASHBY_JOB_BOARD_ID}`;

// The Ashby embed script that exposes `window.__Ashby` and renders the
// application-form iframe. Injected on demand from JobPage.
export const ASHBY_EMBED_SCRIPT_URL = `${ASHBY_JOB_BOARD_URL}/embed?version=2`;
